import React, { ReactElement, useEffect } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import './tezaurusListButtons.scss';
import { useNavigate } from 'react-router';
import iconPlus from '../../../../../../assets/images/icon-plus-dark.svg';
import routes from '../../../../../routing/routes';
import { useClient, useClientStatusContext } from '../../../../../context/ClientStatusContext';
import { exportTerminListAdmin } from '../../../../../client/export/exportTerminListClient';
import {
  technickePricinyErrorStatus,
} from '../../../../../constants/ErrorConstant';
import downloadFile from '../../../../../functions/downloadFile';
import UserRoleEnum from '../../../../../model/currentuser/UserRole';
import Secured from '../../../../Secured';

const TezaurusListActions = (): ReactElement => {
  const navigate = useNavigate();
  const { handleStatus } = useClientStatusContext();

  const {
    wrapClient: exportTerminAdmin,
    status: exportTerminAdminStatus,
  } = useClient(exportTerminListAdmin);

  useEffect(() => {
    if (exportTerminAdminStatus.responseCode >= 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [exportTerminAdminStatus, handleStatus]);

  const onExportToPdf = async (e): Promise<void> => {
    e.preventDefault();
    const { data } = await exportTerminAdmin(undefined, '', undefined, undefined);

    if (data.blob) {
      downloadFile(data.fileName, data.blob);
    }
  };

  return (
    <div>
      <Secured allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS]}>
        <Button
          className="tezaurus-list__add"
          size="large"
          buttonStyle="third"
          type="button"
          iconBefore={iconPlus}
          onClick={() => navigate(routes.tezaurus.admin.create)}
        >
          Pridať tezaurus
        </Button>
      </Secured>
      <LoaderButton
        loading={exportTerminAdminStatus.loading}
        size="large"
        buttonStyle="third"
        type="button"
        onClick={(event) => onExportToPdf(event)}
      >Exportovať termíny (PDF)
      </LoaderButton>
    </div>
  );
};

export default TezaurusListActions;
